export class AppUrl {
  host: string = "https://admapp.loga.net.br";
  host_minha_loga: string = "https://minhaloga.loga.net.br/#";
  minha_loga_version: number = 4.1;
}



// WEBPACK FOOTER //
// /var/www/minhaloga-cliente/src/app/app-url.ts